<template>
  <div>
    <div class="profile-info-block mb-3">
      <div class="profile-edit-block">
        <h2 class="rg-title">学歴</h2>
          <EditButton
            title="編集"
            @click="showModal"
          />
      </div>
      <div class="profile-info">
        <table class="table">
          <tbody>
            <tr>
              <th>最終学歴</th>
              <td>
                <span class="edit-txt" v-if="isAcademyEdit">
                  {{ getFinalEducation(profile.final_education) }}
                </span>
                <div class="custom-form-block edit-custom" v-else>
                  <select
                    class="form-control  pristine-untouched"
                    v-bind:class="{
                      'is-invalid': hasError('final_education', 'academic'),
                    }"
                    name="final_education"
                    v-model="profile.final_education"
                    v-validate="'required'"
                    data-vv-as="最終学歴"
                  >
                    <option value>選択</option>
                    <option
                      v-for="education in finalEducation"
                      v-bind:key="education._id"
                      v-bind:value="education._id"
                    >
                      {{ education.title }}
                    </option>
                  </select>
                  <div
                    class="invalid-feedback"
                    v-if="hasError('final_education', 'academic')"
                  >
                    {{ getErrorMessage('final_education', 'academic') }}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>卒業学校名</th>
              <td>
                <span class="edit-txt" v-if="isAcademyEdit">
                  {{ profile.graduation_school_name }}
                </span>
                <div class="custom-form-block edit-custom" v-else>
                  <input
                    type="text"
                    class="form-control "
                    v-bind:class="{
                      'is-invalid': hasError(
                        'graduation_school_name',
                        'academic'
                      ),
                    }"
                    name="graduation_school_name"
                    v-model="profile.graduation_school_name"
                    v-validate="'required|max:50'"
                    data-vv-as="卒業学校名"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="hasError('graduation_school_name', 'academic')"
                  >
                    {{ getErrorMessage('graduation_school_name', 'academic') }}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                卒業学部名
              </th>
              <td>
                <span class="edit-txt" v-if="isAcademyEdit">
                  {{ profile.graduation_department_name }}
                </span>
                <div class="custom-form-block edit-custom" v-else>
                  <input
                    type="text"
                    class="form-control"
                    v-bind:class="{
                      'is-invalid': hasError(
                        'graduation_department_name',
                        'academic'
                      ),
                    }"
                    name="graduation_department_name"
                    v-model="profile.graduation_department_name"
                    data-vv-as="卒業学部名"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="hasError('graduation_department_name', 'academic')"
                  >
                    {{
                      getErrorMessage('graduation_department_name', 'academic')
                    }}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>卒業年月</th>
              <td>
                <span class="edit-txt" v-if="isAcademyEdit">
                  {{ profile.year_of_graduation }}年
                </span>

                <span class="edit-txt">
                  {{ profile.month_of_graduation || '' }}月
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- </form> -->
    </div>
    <b-modal
      id="academic-edit-modal"
      ref="modal"
      hide-footer
      size="lg"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      @shown="addEventListeners"
      @hide="removeEventListeners"
    >
      <template #modal-header>
        <!-- Emulate built in modal header close button action -->
        <h5 class="sharingTitle" style="margin-top:5px">
          学歴
        </h5>
        <CancelModal @click="cancel" />
        <!-- <img
          src="../assets/close.png"
          v-on:click.prevent="cancel('academic')"
          style="cursor:pointer;margin-top:5px"
        /> -->
        <!-- <button
          data-v-bf1681ae=""
          title="保存"
          class="btn btn-secondary rounded font-16 profile-edit-btn"
          @click="saveAcademicInformation"
        >
          保存
        </button> -->
      </template>
      <form
        v-on:submit.prevent="saveAcademicInformation"
        data-vv-scope="academic"
        style="max-height: 550px;overflow-y:scroll;"
      >
        <div class="form-sep-block">
          <div class="item-form-block">
            <div class="form-group row">
              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge me-2">必須</span>
                  最終学歴
                </label>
                <div class="d-flex justify-content-between flex-column">
                  <select
                    class="form-control "
                    v-bind:class="{
                      'is-invalid': hasError('final_education', 'academic'),
                    }"
                    name="final_education"
                    v-model="profile.final_education"
                    v-validate="'required'"
                    data-vv-as="最終学歴"
                  >
                    <option value>選択</option>
                    <option
                      v-for="education in finalEducation"
                      v-bind:key="education._id"
                      v-bind:value="education._id"
                    >
                      {{ education.title }}
                    </option>
                  </select>
                  <div
                    class="invalid-feedback"
                    v-if="hasError('final_education', 'academic')"
                  >
                    {{ getErrorMessage('final_education', 'academic') }}
                  </div>
                </div>
              </div>

              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge me-2">必須</span>
                  卒業学校名
                </label>
                <input
                  type="text"
                  class="form-control "
                  v-bind:class="{
                    'is-invalid': hasError(
                      'graduation_school_name',
                      'academic'
                    ),
                  }"
                  name="graduation_school_name"
                  v-model="profile.graduation_school_name"
                  v-validate="'required|max:50'"
                  data-vv-as="卒業学校名"
                />
                <div
                  class="invalid-feedback"
                  v-if="hasError('graduation_school_name', 'academic')"
                >
                  {{ getErrorMessage('graduation_school_name', 'academic') }}
                </div>
              </div>

              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge me-2">必須</span>
                  卒業学部名
                </label>
                <input
                  type="text"
                  class="form-control "
                  v-bind:class="{
                    'is-invalid': hasError(
                      'graduation_department_name',
                      'academic'
                    ),
                  }"
                  name="graduation_department_name"
                  v-model="profile.graduation_department_name"
                  v-validate="'required|max:50'"
                  data-vv-as="卒業学部名"
                />
                <div
                  class="invalid-feedback"
                  v-if="hasError('graduation_department_name', 'academic')"
                >
                  {{
                    getErrorMessage('graduation_department_name', 'academic')
                  }}
                </div>
              </div>

              <div class="col-md-12 mb-30">
                <label class="cstm-label">
                  <span class="span-badge me-2">必須</span>
                  卒業年月
                </label>
                <div
                  class="d-flex justify-content-between slct-inline graduation-date"
                >
                  <select
                    class="form-control me-2 pristine-untouched"
                    v-bind:class="{
                      'is-invalid': errors.first(
                        'year_of_graduation',
                        'academic'
                      ),
                    }"
                    name="year_of_graduation"
                    v-model="profile.year_of_graduation"
                    v-validate="'required'"
                    data-vv-as="卒業年月"
                  >
                    <!-- <option value=""></option> -->
                    <option
                      v-for="year in years_of_graduation"
                      :key="year"
                      :value="year"
                    >
                      {{ year }}
                    </option>
                  </select>
                  <label for="years">年</label>
                  <select
                    class="form-control me-4 pristine-untouched"
                    v-bind:class="{
                      'is-invalid': errors.first(
                        'month_of_graduation',
                        'academic'
                      ),
                    }"
                    name="month_of_graduation"
                    v-model="profile.month_of_graduation"
                    v-validate="'required'"
                    data-vv-as="卒業年月"
                  >
                    <!-- <option value=""></option> -->
                    <option v-for="month in months" :key="month" :value="month">
                      {{ month }}
                    </option>
                  </select>
                  <label for="months">月</label>
                </div>
                <div
                  class="invalid-feedback"
                  v-if="hasError('year_of_graduation', 'academic') || hasError('month_of_graduation', 'academic') "
                >
                  {{ getErrorMessage('year_of_graduation', 'academic') || getErrorMessage('month_of_graduation', 'academic') }}
                </div>
              </div>
              <div class="col-md-12 mb-30 text-center">
                <button
                  data-v-bf1681ae=""
                  title="保存"
                  class="btn btn-secondary rounded font-16 profile-edit-btn"
                  @click="saveAcademicInformation"
                >
                  保存する
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <!-- ends custom-form-block -->
    </b-modal>
  </div>
</template>

<script>
import ProfileHeader from '@/components/header.vue';
import Api from '@/config/api';
// eslint-disable-next-line
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import swal from 'sweetalert';
import logo from '../assets/Group300.png';
import modalEventListener from '../mixins/modalEventListener';
import CancelModal from './CancelModal.vue';
import EditButton from './EditButton.vue';

export default {
  components: {
    ProfileHeader,
    CancelModal,
    EditButton,
  },
  mixins: [modalEventListener],
  props: ['finalEducation'],
  data() {
    return {
      data: {},
      server_errors: {},
      tempAcademicData: {},
      isAcademyEdit: true,
      years_of_graduation: [],
      years: [],
      months: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
      ],
    };
  },
  computed: {
    ...mapGetters({
      profile: 'getProfile',
    }),
    birthDate() {
      return moment(this.profile.birth_date).format('YYYY/MM/DD');
    },
  },
  methods: {
    ...mapActions({
      setProfile: 'setProfile',
    }),
    hasError(field, scope = null) {
      return (
        field in this.server_errors || this.errors.first(`${scope}.${field}`)
      );
    },
    getErrorMessage(field, scope = null) {
      if (field in this.server_errors) return this.server_errors[field].msg;
      else if (this.errors.first(`${scope}.${field}`)) {
        return this.errors.first(`${scope}.${field}`);
      }
      return null;
    },
    clearErrors() {
      // clear errors
      this.errors.clear();
      this.server_errors = {};
    },
    getFinalEducation(id) {
      if (this.finalEducation) {
        const result = this.finalEducation.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return '';
    },
    initYearsOfGraduation() {
      const d = new Date();
      const n = d.getFullYear();
      let j = 0;
      for (let i = n - 70; i <= n; i += 1) {
        this.years_of_graduation[j] = i;
        j += 1;
      }
    },
    showModal() {
      this.toggleEdit();
      this.$nextTick(() => {
        const modal = this.$refs.modal;
        if (modal && typeof modal.show === 'function') {
          modal.show();
        }
      });
    },
    cancel() {
      this.isAcademyEdit = true;
      this.profile.final_education = this.tempAcademicData.final_education;
      this.profile.graduation_school_name = this.tempAcademicData.graduation_school_name;
      this.profile.graduation_department_name = this.tempAcademicData.graduation_department_name;
      this.profile.year_of_graduation = this.tempAcademicData.year_of_graduation;
      this.profile.month_of_graduation = this.tempAcademicData.month_of_graduation;
      this.$refs.modal.hide();
    },
    toggleEdit() {
      this.tempAcademicData.final_education = this.profile.final_education;
      this.tempAcademicData.graduation_school_name = this.profile.graduation_school_name;
      this.tempAcademicData.graduation_department_name = this.profile.graduation_department_name;
      this.tempAcademicData.year_of_graduation = this.profile.year_of_graduation;
      this.tempAcademicData.month_of_graduation = this.profile.month_of_graduation;
    },
    async saveAcademicInformation() {
      const changedAcademicData = {
        final_education: this.profile.final_education,
        graduation_school_name: this.profile.graduation_school_name,
        graduation_department_name: this.profile.graduation_department_name,
        year_of_graduation: this.profile.year_of_graduation,
        month_of_graduation: this.profile.month_of_graduation,
      };

      if (this.checkDiff(this.tempAcademicData, changedAcademicData)) {
        const res = await this.confirmSave();
        if (res) {
          await this.save(changedAcademicData, 'academic');
        }
      } else {
        this.cancel('academic');
      }
    },
    checkDiff(actualData, changedData) {
      for (const key of Object.keys(changedData)) {
        if (actualData[key] !== changedData[key]) {
          return true;
        }
      }
      return false;
    },
    async save(data, url) {
      const check = await this.$validator.validateAll(url);
      if (check) {
        try {
          await this.$auth.getToken();
          await this.axios({
            method: 'post',
            data,
            url: Api.url(Api.endpoints[url]),
          });
          if (url === 'academic') {
            this.isAcademyEdit = true;
            this.$refs.modal.hide();
            // swal("", "更新しました。", "success");
          }

          const content = document.createElement('span');
          content.innerHTML =
            '<p style="font-weight:bold">情報を更新しました。</p>';
          swal({
            title: '',
            content,
            className: 'custom-swal4',
            // icon: logo,
            buttons: {
              ok: 'OK',
            },
          });
          this.clearErrors();
          return true;
        } catch (error) {
          console.log(error);
          if (error && error.response && error.response.status === 422) {
            this.server_errors = error.response.data;
          } else if (
            (error.response && error.response.status === 503) ||
            (error.response && error.response.status === 401)
          ) {
            this.$router.push({ name: 'Logout' });
          } else {
            swal('', 'Something Went Wrong', 'error');
          }
          return false;
        } finally {
          swal.close();
        }
      } else {
        swal.close();
      }
    },
    async confirmSave() {
      const res = await swal({
        title: '情報を更新しますか？',
        text:
          '登録企業への公開情報が更新されます。\n 書類（履歴書・職務経歴書等）をアップロードまたは更新した場合、\n 登録企業すべてに同じ書類が公開されます。',
        icon: 'warning',
        className: 'custom-swal',
        closeOnClickOutside: false,
        buttons: {
          cancel: 'キャンセル',
          ok: {
            text: '更新する',
            value: true,
            visible: true,
            closeModal: false,
          },
        },
      });
      return res;
    },
  },
  created() {
    this.initYearsOfGraduation();
  },
};
</script>
<style scoped>
@import url('../assets/css/shared.css');

.graduation-date {
  width: 45%;
}

.graduation-date .form-control {
  margin-right: 5px !important;
}

.graduation-date label {
  display: inline-flex;
  align-items: center;
  margin-right: 5px;
  font-size: 15px;
}

.form-control.is-valid {
  background-image: none;
}
.form-control.is-invalid {
  background-image: none;
}
>>> .sharingTitle {
  margin-top: 5px;
  color: black !important;
  font-weight: 600;
}
</style>
